import axios from 'axios';
import config from 'config';
import { finalize } from "actions/URLfinalizer";
import store from '../store';
import toastr from "toastr"

export const RECEIVE_CONFIG = "RECEIVE_CONFIG"
export function receiveConfig(data) {
	return {
		type: RECEIVE_CONFIG,
		data,
	}
}

export const RECEIVE_CONFIG_FAIL = "RECEIVE_CONFIG_FAIL"
export function receiveConfigFail(data) {
	return {
		type: RECEIVE_CONFIG_FAIL,
		data,
	}
}

export const FETCH_CONFIG = "FETCH_CONFIG"
export function fetchConfig(id) {
	if (!id) {
		id = store.getState().myAccountReducer.user.rootnodeid;
	}

	return dispatch => {
		dispatch({ type: FETCH_CONFIG, id: id });
		return axios.get(finalize(config.api.root + `/devicemanagement/mqttsensor/batch-config/${id}`))
			.then((response) => {
				dispatch(receiveConfig(response.data));
				return response;
			})
			.catch((response) => {
				dispatch(receiveConfigFail(response));
				return response;
			})
	}
}

export const UPDATE_CONFIG = "UPDATE_CONFIG"
export function updateConfig(mac, data, fClose) {
	return dispatch => {
		dispatch({ type: UPDATE_CONFIG, mac, data});

		return axios.put(finalize(config.api.root + `/devicemanagement/mqttsensor/config-nonblocking/${mac}`), data)
			.then((response) => {
				fClose();
				return response;
			})
			.catch((response) => {
				console.log(response);
				fClose();
				return response;
			})
	}
}


// WEBPACK FOOTER //
// ./src/actions/devicemanagement.jsx